/**
 * Labstep
 */

import { Icon } from 'labstep-web/core/Icon';
import React, { useContext } from 'react';
import { SortableItemContext } from '../context';
import styles from './styles.module.scss';
import type { ISortableItemDragHandleProps } from './types';

export const SortableItemDragHandle: RFC<
  ISortableItemDragHandleProps
> = ({ disabled, children }) => {
  const { attributes, listeners, ref } = useContext(
    SortableItemContext,
  );

  return (
    <div
      className={styles.dragHandle}
      {...attributes}
      {...listeners}
      ref={ref}
    >
      {children || (
        <Icon
          className={styles.icon}
          name="bars"
          disabled={disabled}
        />
      )}
    </div>
  );
};
